import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    tone?: 'dark' | 'light'
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            focusable='false'
            className={cn('size-10 shrink-0', className)}
        >
            <rect width='32' height='32' rx='8' className='fill-ink' />

            <g
                fill='none'
                strokeWidth='2.2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='stroke-gold'
            >
                <path d='M5.5 15.5 11 10.5l5.5 5V22h-11z' />
                <circle cx='11' cy='17.6' r='1.5' />
                <path d='M16.5 18.5h10M23 18.5v3M26.5 18.5v2.5' />
            </g>
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    const isLight = tone === 'light'

    return (
        <span className={cn('inline-flex items-center gap-3', className)}>
            <LogoMark className={cn(isLight && 'rounded-[10px] ring-1 ring-gold/35')} />

            <span className='flex flex-col'>
                <span
                    className={cn(
                        'font-heading text-[1.7rem] leading-none tracking-tight',
                        isLight ? 'text-primary-foreground' : 'text-foreground'
                    )}
                >
                    Chave
                </span>

                <span
                    className={cn(
                        'mt-1 text-[0.6rem] font-bold uppercase leading-none tracking-[0.32em]',
                        isLight ? 'text-gold' : 'text-bronze'
                    )}
                >
                    Consórcios
                </span>
            </span>
        </span>
    )
}
